import React, { useState } from "react";
import { FormGroup } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const ToggleSwitch = ({ label, ruleToggle, isActive, i, rowIndex, title }) => {
  const [checked, setChecked] = useState(true);
  // console.log({ checked });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // setChecked(e.target.checked);
    setChecked((checked) => !checked);
    if (ruleToggle) ruleToggle(e);
  };
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            key={i}
            checked={isActive ? checked : ""}
            onClick={()=>handleChange({title, isActive})}
          />
        }
        label={label}
        // label={isActive}
      />
    </FormGroup>
  );
};

export default ToggleSwitch;
